module.exports = __webpack_public_path__ + "img/mfm_logo.23683c4c.jpeg";